import {
    FETCH_MEMBER_HISTORY_REQUEST,
    FETCH_MEMBER_HISTORY_SUCCESS,
    FETCH_MEMBER_HISTORY_FAIL,
    REVERT_MEMBER_REQUEST,
    REVERT_MEMBER_SUCCESS,
    REVERT_MEMBER_FAIL,
    CLEAR_MEMBER_HISTORY
} from '../actions/memberHistory';

import { UPDATE_MEMBER_SUCCESS } from '../actions/member';

const initialState = {
    history: [],
    loading: false,
    error: null,
    currentMemberId: null,
    reverting: false,
    revertError: null
};

function memberHistoryReducer(state = initialState, action) {
    switch (action.type) {
        case FETCH_MEMBER_HISTORY_REQUEST:
            return {
                ...state,
                loading: true,
                error: null,
                currentMemberId: action.memberId
            };

        case FETCH_MEMBER_HISTORY_SUCCESS:
            return {
                ...state,
                loading: false,
                history: action.history,
                currentMemberId: action.memberId,
                error: null
            };

        case FETCH_MEMBER_HISTORY_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                history: []
            };

        case REVERT_MEMBER_REQUEST:
            return {
                ...state,
                reverting: true,
                revertError: null
            };

        case REVERT_MEMBER_SUCCESS:
            return {
                ...state,
                reverting: false,
                revertError: null
            };

        case REVERT_MEMBER_FAIL:
            return {
                ...state,
                reverting: false,
                revertError: action.error
            };

        case CLEAR_MEMBER_HISTORY:
            return initialState;

        // When a member is updated via REVERT_MEMBER_SUCCESS, this updates the members list
        case UPDATE_MEMBER_SUCCESS:
            return state;

        default:
            return state;
    }
}

export default memberHistoryReducer;
